module.exports = __webpack_public_path__ + "img/Shivam_gr.fe55124e.jpg";